import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const productImage = 'https://my.adcombo.com/offer_preview/35631/Matcha_Slim_Costa_Rica_2_1.jpg'; 

const buttonVariants = {
  hover: { scale: 1.1 },
};

const styles = {
  container: {
    marginTop: '2rem',
  },
  image: {
    width: '100%',
    display: 'block',
    margin: '0 auto',
    borderRadius: '10px',
  },
  button: {
    backgroundColor: 'black',
    color: 'white',
    padding: '1rem',
    width: '100%',
    marginTop: '1rem',
    borderRadius: '5px',
  },
  heading: {
    marginBottom: '1rem',
  },
  subHeading: {
    marginBottom: '0.5rem',
  },
  description: {
    marginBottom: '1rem',
  },
};

const MatchaSuri = () => {
  const handleButtonClick = (url) => {
    window.location.href = url;
  };

  return (
    <Container maxWidth="md" style={styles.container}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            src={productImage}
            alt="Polvo de Matcha Suri"
            style={styles.image}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" gutterBottom style={styles.heading}>
            Matcha Suri
          </Typography>
          <Typography variant="body1" style={styles.description}>
            SOBRE EL POLVO DE MATCHA SURI:
            <br />
            - Mezcla amigable y limpia endulzada con sucralosa.
            <br />
            - Use nuestra mezcla de polvo de matcha como té matutino o para preparar tés nutritivos y energizantes.
            <br />
            MEJORADO CON TAURINA Y ESPIRULINA:
            <br />
            - La bebida está compuesta por extractos de origen vegetal cargados de vitaminas y nutrientes.
            <br />
            FORMULADO PARA HOMBRES Y MUJERES:
            <br />
            - Esta mezcla en polvo es perfecta para hombres y mujeres. Agréguela a su rutina matutina para mantenerse alerta durante el día o bébala por la noche si planea quedarse despierto toda la noche.
            <br />
            BEBIDA HONESTA Y PURA:
            <br />
            - La bebida comestible de polvo de té verde matcha de grado alimenticio es 100% no transgénica, sin azúcar, vegana y libre de crueldad.
          </Typography>
          <Typography variant='body1' style={styles.description}>
            Cómo usar: 1 porción al día. Mezcle 1 cucharadita con un vaso (150 ml) de agua caliente hasta su completa disolución.
          </Typography>
          <Typography variant="h6" style={styles.subHeading}>
            Seleccione su país para comprar
          </Typography>
          <Typography variant="subtitle1" gutterBottom style={styles.subHeading}>
            Sólo serás elegible para las mejores ofertas cuando selecciones el país correcto.
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <motion.button
                whileHover={buttonVariants.hover}
                onClick={() => handleButtonClick('https://uh5d0278e7uh.axdsz.pro/?target=-7EBNQCgQAAAcX4wEDBIQABQEBEREKEQkKEQ1CEQ0SAAF_YWRjb21ibwEx&al=94268&ap=-1')}
                style={styles.button}
              >
                México
              </motion.button>
            </Grid>
            <Grid item xs={6}>
              <motion.button
                whileHover={buttonVariants.hover}
                onClick={() => handleButtonClick('https://uh5d0278e7uh.axdsz.pro/?target=-7EBNQCgQAAAcX4wED-JQABQEBEREKEQkKEQ1CEQ0SAAF_YWRjb21ibwEx&al=99801')}
                style={styles.button}
              >
                Puerto Rico
              </motion.button>
            </Grid>
            <Grid item xs={6}>
              <motion.button
                whileHover={buttonVariants.hover}
                onClick={() => handleButtonClick('https://uh5d0278e7uh.axdsz.pro/?target=-7EBNQCgQAAAcX4wED-JQABQEBEREKEQkKEQ1CEQ0SAAF_YWRjb21ibwEx&al=99801')}
                style={styles.button}
              >
                USA
              </motion.button>
            </Grid>
            <Grid item xs={6}>
              <motion.button
                whileHover={buttonVariants.hover}
                onClick={() => handleButtonClick('https://uh5d0278e7uh.axdsz.pro/?target=-7EBNQCgQAAAcX4wEDL4sABQEBEREKEQkKEQ1CEQ0SAAF_YWRjb21ibwEx&al=92475')}
                style={styles.button}
              >
                Honduras
              </motion.button>
            </Grid>
            <Grid item xs={6}>
              <motion.button
                whileHover={buttonVariants.hover}
                onClick={() => handleButtonClick('https://uh5d0278e7uh.uewhbgfvds.cc/?target=-7EBNQCgQAAAcX4wEDMIsABQEBEREKEQkKEQ1CEQ0SAAF_YWRjb21ibwEx')}
                style={styles.button}
              >
                El Salvador
              </motion.button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MatchaSuri;
